import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/online-customer-service-fe/app/components/home/index.tsx");
